
namespace RioERP.Shipping {

    @Serenity.Decorators.registerClass()
    export class ShippingProvidersGrid extends Serenity.EntityGrid<ShippingProvidersRow, any> {
        protected getColumnsKey() { return ShippingProvidersColumns.columnsKey; }
        protected getDialogType() { return ShippingProvidersDialog; }
        protected getIdProperty() { return ShippingProvidersRow.idProperty; }
        protected getInsertPermission() { return ShippingProvidersRow.insertPermission; }
        protected getLocalTextPrefix() { return ShippingProvidersRow.localTextPrefix; }
        protected getService() { return ShippingProvidersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}